import type { InputHTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../utils/class-names';

import styles from './radio.module.css';

export type RadioProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * @param {ReactNode} [children] Text to be displayed next to the element.
 * @default undefined
 */
export function Radio({ className, style, children, ...props }: RadioProps) {
  return (
    <label className={classNames(styles.radio, props.disabled && styles.disabled, className)} style={style}>
      <input type="radio" className={styles.input} {...props} />
      <span className={styles.icon} />
      {children}
    </label>
  );
}
